// extracted by mini-css-extract-plugin
module.exports = {"stats-row":"styles_stats-row__EUZ6O","stat":"styles_stat__wio2z","stat__value":"styles_stat__value__dg2zN","stat__label":"styles_stat__label__ik6r_"};